<template>
   <v-card
   max-width="900px"
    class="mx-auto fill-height px-5"
   fluid
    :flat="true"
    :dark="false"
    :color="'transparent'"
   
  >

        <v-card-text v-if="preview && !Role('lead')" class="pa-0">
                      
                        <v-sheet
                                
                              width="100%"
                              :min-height="!Role('lead') ? '85vh': ''"
                              elevation="2"
                              color="white"
                              tile
                              class="google-doc mt-5 py-5 mx-auto"
                              id="supplierName"
                              contenteditables="true"
                            > 
                            <v-hover v-slot:default="{ hover }">
                                <v-toolbar dense flat color="transparent" class="doc-header" >
                                     <v-btn v-if="!deeplink || Role('lead')" icon to="/" >
                                             <v-icon :color="hover ? 'primary' : 'grey lighten-3'" style="font-size: 2.5em;">arrow_back</v-icon>
                                            </v-btn>
                                    <v-toolbar-title v-if="showHeader && !Role('lead')" :class="{'grey--text lighten-3': !hover}">
                                    {{relation.name}}
                            </v-toolbar-title>
                            <v-toolbar-title v-else-if="showHeader" :class="{'grey--text lighten-3': !hover}">
                                    {{selected._supplier.name}}
                            </v-toolbar-title>
                                      <v-spacer></v-spacer>
                                      <v-btn v-if="!show_info"
                                             icon
                                             @click="show_info=true"
                                            >
                                                  <v-icon color="primary" >more_horiz</v-icon>
                                         </v-btn> 
                                           <v-btn icon @click="togglePreview()" v-if="Role('nobody')">
                                             <v-icon  :color="hover ? 'primary' : 'grey lighten-3'" v-if="preview">edit</v-icon>
                                             <v-icon  :color="hover ? 'primary' : 'grey lighten-3'" v-else="">remove_red_eye</v-icon>
                                             </v-btn>    
                                      <v-btn icon
                                               @click="download"
                                               v-if="!Role('_supplier')"
                                            >
                                             <v-icon :color="hover ? 'primary' : 'grey lighten-3'">print</v-icon>
                                            </v-btn>
                                            </v-toolbar>
                            </v-hover>
                          <template v-if="Role('lead,admin,reseller')">
                               <v-hover v-slot:default="{ hover }">
                                  <div v-if="show_info" class="mb-5 pl-5" >
                                        <v-btn v-if="hover"  class="hide-button" icon @click="show_info=false" style="margin-top: -10px;"><v-icon>close</v-icon></v-btn>
                                         <b style="font-size: 16px;">Opmerking</b>
                                              <v-textarea 
                                                    v-model="selected.description"
                                                  auto-grow
                                                  hide-details
                                                  placeholder="..."
                                                  @change="save"
                                                  class="pa-0 ma-0 border-less mt-1"
                                                  :rows="1"
                                                  style="font-size:inherit!important;"
                                                ></v-textarea>
                                                
                                </div>
                                </v-hover>
                                <!--div v-if="show_info && selected._match.description_specific" class="mb-5 pl-5" >
                                    <b style="font-size: 16px;">{{selected._supplier.name}} wilt u graag wat meer vertellen over:</b>
                                    <p>{{selected._match.description_specific}}</p>
                                </div>
                                <div v-if="show_info && selected._match.description_question" class="mb-5 pl-5" >
                                    <b style="font-size: 16px;">{{selected._supplier.name}} heeft specifieke vragen over:</b>
                                    <p>{{selected._match.description_question}}</p>
                                </div>
                                <div v-if="show_info && selected._match.description_nkc" class="mb-5 pl-5" >
                                    <b style="font-size: 16px;">Opmerking vanuit het Nederlands Kennis Centrum</b>
                                    <p>{{selected._match.description_nkc}}</p>
                                </div>
                                <div v-if="show_info && selected._match.references" class="mb-5 pl-5" >
                                    <b style="font-size: 16px;">{{selected._supplier.name}} heeft de volgende referenties opgegeven</b>
                                    <p>{{selected._match.references.join(', ')}}</p>
                                </div-->
                            </template>
                            <template v-else>
                                    <div v-if="show_info && Role('_admin,_reseller') && selected._match" class="mb-5 pl-5" >
                                        <b style="font-size: 16px;">Opmerking vanuit het Nederlands Kennis Centrum</b>
                                         <v-textarea 
                                                        v-model="selected._match.description_nkc"
                                                      auto-grow
                                                      :hide-details="selected._match.description_nkc==''"
                                                      placeholder="Opmerking..."
                                                      @change="save"
                                                      class="pa-0 ma-0 border-less mt-1"
                                                      :rows="1"
                                                      style="font-size:inherit!important;"
                                                      :readonly="Role('lead')"
                                                      :counter="maxText"
                                                    ></v-textarea>
                                    </div>
                                     <div v-if="show_info && selected._match" class="mb-5 pl-5" >
                                            <b style="font-size: 16px;">Over {{relation.name}}:</b>
                                                  <v-textarea
                                                        v-model="selected._match.description"
                                                      auto-grow
                                                      :hide-details="selected._match.description==''"
                                                      
                                                      placeholder="Opmerking..."
                                                      @blur="save"
                                                      class="pa-0 ma-0 border-less mt-1"
                                                      :rows="1"
                                                      style="font-size:inherit!important;"
                                                      :readonly="Role('lead')"
                                                      :counter="maxText"
                                                    ></v-textarea>
                                    </div>
                                    <div v-if="show_info && selected._match" class="mb-5 pl-5" >
                                            <b style="font-size: 16px;">Vertel {{selected.name}} over</b>
                                                  <v-textarea
                                                        v-model="selected._match.description_specific"
                                                      auto-grow
                                                     :hide-details="selected._match.description_specific==''"

                                                      placeholder="Opmerking..."
                                                      @change="save"
                                                      class="pa-0 ma-0 border-less mt-1"
                                                      :rows="1"
                                                      style="font-size:inherit!important;"
                                                      :readonly="Role('lead')"
                                                      :counter="maxText"
                                                    ></v-textarea>
                                    </div>
                                    <div v-if="show_info && selected._match" class="mb-5 pl-5" >
                                            <b style="font-size: 16px;">Specifieke vragen aan {{selected.name}}</b>
                                                  <v-textarea
                                                        v-model="selected._match.description_question"
                                                      auto-grow
                                                      :hide-details="selected._match.description_question==''"
                                                      placeholder="Opmerking..."
                                                      @change="save"
                                                      class="pa-0 ma-0 border-less mt-1"
                                                      :rows="1"
                                                      style="font-size:inherit!important;"
                                                      :readonly="Role('lead')"
                                                      :counter="maxText"
                                                    ></v-textarea>
                                    </div>
                                    
                                    <div v-if="show_info && selected._match" class="mb-5 pl-5" >
                                            <b style="font-size: 16px;">Referenties gelijk aan {{selected.name}}</b>
                                                <v-combobox ref="combobox"
                                                        v-model="selected._match.references"
                                                        hide-details
                                                        flat
                                                        solo
                                                        full-width
                                                        dense
                                                        chips
                                                        multiple
                                                        autofocus
                                                        @blur="save"
                                                        class="transparent mt-5"
                                                        placeholder="Type de naam van de referentie"
                                                        style="font-size:inherit!important;"
                                                        :readonly="Role('lead')"
                                                      >
                                                        <template v-slot:selection="data">
                                                            <v-chip
                                                              
                                                              outlined
                                                              :key="JSON.stringify(data.item)"
                                                              v-bind="data.attrs"
                                                              :input-value="data.selected"
                                                              :disabled="data.disabled"
                                                              @click:close="data.parent.selectItem(data.item)"
                                                            >
                                                              <v-avatar
                                                                class="accent white--text"
                                                                left
                                                                v-text="data.item.slice(0, 1).toUpperCase()"
                                                              ></v-avatar>
                                                              {{ data.item }}
                                                            </v-chip>
                                                          </template>
                                                      </v-combobox>
                                    
                                    </div>
                          </template>
                         
                          <v-divider v-if="show_info" class="mb-5"></v-divider>
                          
                          <core-empty v-if="answers.length==0 && !currentQuestion.title" icon="library_books" text="Rapportage" description="Voeg antwoorden en opmerkingen toe aan de vragen in het menu en bouw zo het Case rapport op."></core-empty>
                            
                            <questionaire-report ref="chatbar" :chatMessage="chatMessage" :isMain="isMain" :app="false" :show_info="show_info" :index="index" :impersonate="impersonate" @answer="answerThis" @save="save" @scroll="scroll"></questionaire-report> 
                             <questionaire-add loading="loading" @add="save" @menu="tab='list'" v-if="Role('lead')"></questionaire-add>
                            <div><br><br><br></div>
                            
                    </v-sheet>
      
      
           <v-card flat color="transparent" class="mt-5" v-if="Role('lead')">
           
         
          <questionaire-templates group="true" ref="templates" :all="all" app="true" @addall="save" @add="save" :searchOnly="true"></questionaire-templates>
          </v-card>
    
    </v-card-text>
     <v-card-text ref="content" class="pa-0 mt-5 scroll-content" flat v-else-if="questions.length>0">
         <v-card flat tile color="transparent">
         <v-toolbar flat tile :color="Role('lead') ? 'accent' : 'transparent'" :dark="Role('lead')">
              <v-btn v-if="!Role('lead')" icon @click="setPreview(true);setMenu(true)">
                <v-icon>arrow_back</v-icon>
              </v-btn>
               <v-btn v-else-if="!deeplink || Role('lead')" icon to="/" >
                                             <v-icon style="font-size: 2.5em;">arrow_back</v-icon>
                                            </v-btn>
              <v-toolbar-title>Vragenlijst: {{selected._supplier.name}}</v-toolbar-title>
              <v-spacer></v-spacer>
               <v-btn icon
                   @click="download"
                   v-if="!Role('_supplier')"
                >
                 <v-icon >print</v-icon>
                </v-btn>
              <v-btn icon v-if="false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-hover v-slot:default="{ hover }">
                              <div v-if="show_info && !Role('lead')" class="pa-5 ma-5">
                                    <v-btn v-if="hover"  class="hide-button" icon @click="show_info=false"><v-icon>close</v-icon></v-btn>
                                     <b>Opmerking</b>
                                          <v-textarea
                                                v-model="selected.description"
                                              auto-grow
                                              hide-details
                                              :autofocus="hover"
                                              placeholder="Opmerking..."
                                              @blur="save"
                                              class="pa-0 ma-0 border-less"
                                              :rows="1"
                                              style="font-size:inherit!important;"
                                            ></v-textarea>
                            </div>
                            <div v-else><br></div>
                            </v-hover>
    <questionaire-edit :max="max" :isMain="isMain" @save="save"></questionaire-edit>
                     <v-card class="mx-5" flat color="transparent">
                         <questionaire-add loading="loading" @add="save" @menu="tab='list'"></questionaire-add>
                         <questionaire-templates group="true" ref="templates" :all="all" app="true" @addall="save" @add="save"  :searchOnly="true"></questionaire-templates>
                    </v-card>
    
  
  
    <!--questionaire-list v-else :max="max" :disabled="selected.disabled" :isMain="isMain"></questionaire-list-->
    </v-card>
    </v-card-text>
   <v-card-actions id="questionCard" class="footer">
                
               
              <v-spacer></v-spacer>
               
               
              </v-card-actions>
             
             </v-card>
             
</template>
<script>


import jsPDF from "jspdf";
import axios from 'axios'
import {
  mapState, mapMutations, mapGetters
} from 'vuex'

export default {
  props: ['isMain','index','impersonate'],
  data: () => ({
     input: '',
     max: 5,
     loading: false,
     overlay: true,
     description: '',
     show_info: true,
      chatMessage: '',
      maxText: 300
  }),
  computed: {
     ...mapGetters('auth', ["Role"]),
    ...mapState('auth', ["settings",'relation']),
    ...mapState('app', ["menu","mini","chat","edit","template","preview","deeplink"]),
     ...mapState('match', ['selected']),
      ...mapGetters('match', ['currentQuestion','search']),
       messages () {
        if (!this.selected.answers) return []
        return this.selected.answers.filter(a => a.question == null)
      },
      showHeader(){
        return this.relation._id != this.settings._id || this.Role('lead')
      },
       showMenu: {
          get() {
            return this.menu && !this.preview
          },
          set(value) {
            this.setMenu(value)
          }
        },
      all () {
        if (this.search && this.search.length > 0) return true
        return false
      },
      style () {
         if (this.preview) return "overflow: auto;height: calc(100vh - 100px);position:relative;"  
        return "overflow: auto;height: calc(100vh - 180px);position:relative;"  
      },
      style2 (){
        return this.style
      },
      dialog: {
          get() {
            return this.preview
          },
          set(value) {
            this.setPreview(value)
          }
      },
      showChat: {
          get() {
            return this.chat
          },
          set(value) {
            this.setChat(value)
          }
      },
       placeholder () {
        if (this.question && this.question.title) return "Opmerking bij '" + this.question.title + "'"
        return 'Opmerking...'
        },
      hasOwn () {
        return (this.selected.questions && this.selected.questions.length > 0) || (this.selected.answers && this.selected.answers.length > 0)
      },
      isEmpty () {
          if (this.selected.description) return false
         return !this.selected.questions || this.selected.questions.length==0
      },
      questions () {
          return this.selected.questions
      },
      answers () {
          return this.selected.answers
      },
      name () {
          if (this.selected._supplier) return this.selected._supplier.name
          return ''
      },
      tags () {
        if (this.selected.tags) return this.selected.tags.filter(q=> q.type=='branche' || q.type=='category' || q.type=='type').map(t => {
            if (t.type == 'category' || t.type == 'type') {
              t.path = t.path.replaceAll(' / ', '###')
              t.name = t.path.split('/').map(c => c.capitalize()).join(', ').replaceAll('###',' / ')
            }
            return t.name
        }) //
        return []
      }
  },
  watch: {
    selected (val, old)  {
        this.show_info = true
        if (this.questions.length > 0 && this.Role("admin,reseller") ) {
            this.setPreview(true)
            this.setMenu(true)
        }
    }
  },
  mounted () {
     // console.log(this.$router.currentRoute)
    if (!this.Role("admin,reseller") && (this.questions.length > 0 || this.$router.currentRoute.params.index)) this.setPreview(false)
    if (this.Role("supplier")) this.setPreview(true)
    this.load();     
    
  },
  destroyed(){
        this.$emit('save')
    },
  methods: {
     ...mapMutations('app', ["toggleMenu","setMenu","toggleChat","setChat", "toggleEdit","setTemplate", "setPreview","togglePreview"]),
     ...mapMutations('match', ["reset","setTemplates","addDescription","setSearch"]),
     home () {
         this.$emit('home')  
     },
      mainContacts(match){
        if (match._supplier.contacts.filter(c => c.main==true).length == 0) match._supplier.contacts[0]
        return match._supplier.contacts.filter(c => c.main==true)
      },
     addChat () {
         this.$refs.chatbar.addChat()
         this.chatMessage = ''
     },
     save(){
         this.setSearch('')
          this.$emit('save')
     },
     load () {
         
     },
     answerThis(question) {
        this.$emit('answer', question)
      },
       timeStamp (date){
        if (!date) return
        var m = this.$moment(date, this.$moment.ISO_8601)
        if (!m.isValid()) return this.$moment().format("dddd D MMMM [om] HH:mm")
        return   m.format("dddd D MMMM [om] HH:mm");
      },
     download() {
        const doc = new jsPDF();
        var self = this
        let rMargin = 10
        doc.setFont('helvetica')
        doc.setFontType('bold')
        doc.setLineWidth(0.1)
        doc.setDrawColor(200,200, 200) // draw red lines
        doc.setFontSize(22)
        doc.text(rMargin, 20, "Vragenlijst: " + this.selected._supplier.name)
        doc.setFontType('normal')
        doc.setFontSize(10)
        var t = ''
        if (this.selected.event_date) t = this.timeStamp(this.selected.event_date) + ': '
        t += this.mainContacts(this.selected).map(a => a.name).join(', ')
        doc.text(rMargin, 30, t)
        var line = 50 
        
        this.questions.forEach(function(question, nr){
           doc.setFontSize(10)
           //doc.setFontType('bold')
          //+ (question.title.indexOf('?') == -1) ? '?' : ''
          doc.text(rMargin, line, (nr+1) + '. ' + question.title )
          doc.setFontType('normal')
          doc.setFontSize(9)
          if (question.description) {
            doc.text(rMargin, line+5, question.description )
          }
          var max = 6
          if (question.options) {
             question.options.forEach(function(Option,iii){
               var v = line*1+(10*iii) 
               doc.rect(rMargin, v + 3, 5, 5); 
               doc.text(rMargin+10, v+ 7, Option )
             })
          }
          for (var x = 0; x < max; x++) {
             line += 10
            doc.line(rMargin, line, 200, line)
          }
          line+=20
          if ([2,5,7,9].indexOf(nr) > -1 && self.questions.length > nr+1) {
            doc.addPage()
            line = 20
          }
        })
        /*
         <b>{{timeStamp(selected.event_date)}}</b><span v-for="(contact) in mainContacts(selected)" :key="contact.name">, {{contact.name}}</span>
            <div class="print-question" v-for="(question, index) in questions" :key="index">
            
              <h3><b class="mr-2">{{index+1}}.</b> {{question.title}}{{questionMark(question)}}</h3>
              <p v-if="question.description" class="pb-2">{{question.description}}</p>
        
        */
        
        
        doc.output("dataurlnewwindow"); 
      },
      editInfo(){
        this.selected.edit=true;
        this.overlay=false;
        this.description = this.selected.description
      },
      scroll(){
          if (this.$refs.chatWindow) {
            var messageDisplay = this.$refs.chatWindow //.$el.querySelector(".v-navigation-drawer__content");
            messageDisplay.scrollTop = messageDisplay.scrollHeight + 100;
        }
      },
     avatar (url) {
          return this.$config.getIMageLink('logo',url,true)
        }
  }
};

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
</script>
<style>
.v-application {
    font-family: Arial, "Roboto", sans-serif;
    line-height: auto;
}
.google-doc {
    /*font-family: Arial;
    font-size: 14px;*/
    padding: 70px 20px 70px 89px;
    cursor: pointer;
}
.doc-header {
    margin-left: -80px;
    margin-right: -10px;
    margin-top: -15px;
    margin-bottom: 50px;
}
 .transparent button{
     border: 0px!important;
 }
 
 .sticky-top {
     position:sticky;
     top:0px;
     z-index:1
 }
 
 .v-card__text .scroll-content{
         min-height: 90%;
 }
 .v-text-field.border-less > .v-input__control > .v-input__slot:before {
    border-color: transparent;
}
 
 .sticky-bottom {
     position: -webkit-sticky; /* Safari */  
    position: sticky;
    width: 100%;
    bottom: 0px;
    
 }
.sticky-bottom .white--background{
    background: white;
}
.v-toolbar__extension {
    padding: 0px;
}
.hide-button{
    float: right;
    z-index: 10;
}
</style>